import { render } from "./ConfigurationView.vue?vue&type=template&id=9ac40770"
import script from "./ConfigurationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationView.vue?vue&type=script&lang=js"

import "./ConfigurationView.vue?vue&type=style&index=0&id=9ac40770&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__